import React from 'react';

function AppBar({
  children,
  className = '',
  component = 'header',
  position = 'static',
  ...rest
}) {
  const Element = component;
  const appBarClassName = [
    'custom-app-bar',
    `custom-app-bar--${position}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Element className={appBarClassName} {...rest}>
      {children}
    </Element>
  );
}

export default AppBar;
